import { FormCheckboxField, lt, useFieldDependency } from '@mews/framework';
import { FieldNames } from '../fieldNames';
import { MicrosConfigurationFormSchema } from '../formProps';
import { useDirtyFormState } from './useDirtyFormState';

export const GenerateReversalTransactionField = () => {
    const isFormDirty = useDirtyFormState();
    const { dependencyValue } = useFieldDependency<
        MicrosConfigurationFormSchema,
        FieldNames.detailedBillingConfigurationUseDetailedBilling
    >({
        name: FieldNames.detailedBillingConfigurationGenerateReversalTransaction,
        dependency: FieldNames.detailedBillingConfigurationUseDetailedBilling,
        setInitialValueDisabled: !isFormDirty,
    });

    return (
        <FormCheckboxField
            name={FieldNames.detailedBillingConfigurationGenerateReversalTransaction}
            disabled={!dependencyValue}
        >
            {lt('GenerateReversalTransaction')}
        </FormCheckboxField>
    );
};
